import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const CircularProgressBar = (currentProgress, uploadSuccessfully, uploadFailed) => {
  let progress = currentProgress;
  let progressBarColor = "";
  let value = 0;

  if (!uploadSuccessfully && !uploadFailed && !progress) {
    progressBarColor = "#ddd";
    value = 100
  } else {
    value = progress;
    if (progress !== 0 && progress !== 100) {
      progressBarColor = "#00acc1";
    } else {
      if (progress === 100) {
        progressBarColor = "#5cb860";
      } else if (progress === 0) {
        progressBarColor = "#f44336";
      }
    }
  }

  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant="static"
        value={value}
        style={{ color: progressBarColor, transition: "color 0.3s" }}
        data-testid="circularProgressBar"
      />
      <Box
        top={0}
        left={0}
        bottom={-2}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color="textSecondary" data-testid="progressBarValue">
          {uploadFailed ? 100 - progress : progress}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressBar;